// @ts-ignore
import BackButtonActions from "@cirrus/legacy/app-author/common/back-button-component/actions.js"

export function initBreadcrumbs(breadcrumbs) {
  // @ts-ignore
  App.BreadcrumbsInitialized.then(() => {
    // @ts-ignore
    App.vent.trigger("put:breadcrumb", breadcrumbs)
    BackButtonActions.show(breadcrumbs[0].title)
  })
}
